export default __webpack_public_path__ + "static/investment-image-6-762d53b0014a26fc70b68ecef87cc27c.jpg";